import * as React from 'react'
import Alert from '@mui/material/Alert'

import type { ILeadOppProduct } from '@user/store/leadOppProducts'

import { useServiceCheckboxes } from './hooks'
import { AlertError } from '../../../atoms'
import { ScheduleService } from './ScheduleService'
import { ScheduleEstimate } from './ScheduleEstimate'
import Typography from '@mui/material/Typography'

export type ServiceCheckboxesProps = {
  services: ILeadOppProduct[]
}

export function ServiceCheckboxes(props: ServiceCheckboxesProps) {
  const {
    onChange,

    mode,
    errorStr,
    showInfo,
    showError,
    noServices,
    allScheduled,
    serviceOptions,
  } = useServiceCheckboxes(props)

  return (
    <>
      <Typography variant="subtitle3" mt={2} mb={1.6}>
        Select Services Added
      </Typography>

      {showInfo && (
        <Alert sx={{ mb: 1 }} severity="info">
          Select a location
        </Alert>
      )}

      {noServices && (
        <Alert sx={{ mb: 1 }} severity="info">
          Selected location has no services
        </Alert>
      )}

      {allScheduled && (
        <Alert sx={{ mb: 1 }}>
          All services for this location have already been scheduled
        </Alert>
      )}

      {showError && <AlertError sx={{ mb: 1 }}>{errorStr}</AlertError>}

      {mode === 'service' ? (
        <ScheduleService onChange={onChange} serviceOptions={serviceOptions} />
      ) : (
        <ScheduleEstimate onChange={onChange} serviceOptions={serviceOptions} />
      )}
    </>
  )
}
